import * as React from 'react'
import * as ReactDOM from 'react-dom';
import { Route, Redirect } from 'react-router'
import { HashRouter } from 'react-router-dom'

// Common components
import ChuFormProvider from '../common/components/chu-form-provider'
import Spinner from '../common/components/spinner'
import Message from '../common/components/message'
import CurrentProgress from '../common/components/current-progress'
import FullPageContent from '../common/components/full-page-content'
import RouteContainer from '../common/components/route-container'
import DocumentHeader from '../common/components/document-header'
import '../common/common-styles.css'
import {getQueryString} from '../isaver-quote/util'

// Custom components
import IsaverQuoteHeader from './components/isaver-quote-header'

// Common routes
import Payment from '../common/routes/payment'
import IndexRoute from '../common/routes/index-route'
import PaymentOffline from '../common/routes/payment-offline'
import PaymentByCard from '../common/routes/payment-by-card'
import PaymentResult from '../common/routes/payment-result'
import Restore from '../common/routes/restore'
import Declined from '../common/routes/declined'

// Project routes
import Step1 from './routes/step-1'
import Step2 from './routes/step-2'
import Step3 from './routes/step-3'
import Step4 from './routes/step-4'
import Step5 from './routes/step-5'
import Step6 from './routes/step-6'
import Step7 from './routes/step-7'
import Step8 from './routes/step-8'


// Project specific
import reducers from './reducer-map'
import CHUiSaverFooter from '../isaver-quote/components/footer'
import '../common/isaver-style-override.css'

const referenceCode = getQueryString().referenceCode ? getQueryString().referenceCode.trim() : "";
const linkSuffix = referenceCode ? "?referenceCode=" + referenceCode : ""
console.log(referenceCode);


export default class extends React.Component<{}, {}>{

    
    constructor(props){
        super(props)
    }


    render(){
        return (
            <ChuFormProvider reducers={ reducers }>
                <div className="app app-isaver">
                    <DocumentHeader icon={ require('./images/favicon.ico') } />
                    <Spinner/>
                    <Message/>
                    <IsaverQuoteHeader/>
                    <HashRouter>
                        <FullPageContent>
                            <CurrentProgress hidePillsWhenSm extra={ <a href="mailto:info@flexinsurance.com.au" style={{position:'relative', top:'-4px'}}><i className="hidden-md-up fa fa-envelope-square fa-2x"></i> <span className="pt-0" style={{position:'relative', top:'-6px', marginRight:'3px'}}>info@flexinsurance.com.au</span> <i className="hidden-sm-down fa fa-envelope-square fa-2x"></i></a> }/>
                            <RouteContainer>
                                <Route exact path="/" component={ IndexRoute } />
                                <Route path="/step-1" component={ Step1 } />
                                <Route path="/step-2" component={ Step2 } />
                                <Route path="/step-3" component={ Step3 } />
                                <Route path="/step-4" component={ Step4 } />
                                <Route path="/step-5" component={ Step5 } />
                                <Route path="/step-6" component={ Step6 } />
                                <Route path="/step-7" component={ Step7 } />
                                <Route path="/step-8" component={ Step8 } />
                                <Route path="/payment" component={ Payment }/>
                                <Route path="/payment-offline" component={ PaymentOffline } />
                                <Route path="/payment-by-card" component={ PaymentByCard } />
                                <Route path="/payment-result" component={ PaymentResult } />
                                <Route path="/restore" component={ Restore } />
                                <Route path="/declined" component={ Declined } />

                                <Route path="/!/restore" component={ Restore } />
                                <Route path="/!/step-1" component={ Step1 } />
                            </RouteContainer>
                        </FullPageContent>
                    </HashRouter>
                    <CHUiSaverFooter/>
                </div>
            </ChuFormProvider>
        )
    }
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/isaver-quote-root-component.tsx